import React, { useEffect, useState } from "react";
import {
  Layout,
  Row,
  Col,
  Menu,
  Image,
  Typography,
  Divider,
  Tabs,
  Button,
  Card,
} from "antd";
import { mockData } from "./mock";
import styles from "./PlatformFusion.module.scss";
import DownArrow from "@assets/KPMG/DownArrow.svg";
import Percent from "@assets/KPMG/percent.svg";
import Rating from "@assets/KPMG/rating.svg";
import Location from "@assets/KPMG/location.svg";
import { Fade } from "react-awesome-reveal";

interface Props {
  type: string;
}

export const TabInfo = ({ type }: Props) => {
  const [selectedContent, setSelectedContent] = useState<any>({});
  useEffect(() => {
    if (type) {
      if (mockData[type]) {
        setSelectedContent(mockData[type]);
      }
    }
  }, [type]);

  const updateSelectedTab = (item: any) => {
    setSelectedContent(item);
  };

  return (
    <>
      <div className="newsList">
        <Fade direction="right" triggerOnce>
          <div style={{ margin: "20px 0", width: "100%" }}>
            <div style={{ marginBottom: 40 }}>
              <Row>
                {selectedContent &&
                  selectedContent.length > 0 &&
                  selectedContent.map((item: any, index: number) => {
                    return (
                      <Col md={20} sm={6} key={index}>
                        <div
                          style={{
                            background: "#F7FAFF",
                            marginBottom: 10,
                            borderRadius: "4px",
                            padding: "10px 24px",
                          }}
                        >
                          <Row gutter={[0, 0]}>
                            <Col span={18}>
                              <Typography.Link
                                style={{ color: "rgb(0, 48, 135)" }}
                                href={item.link}
                                target="_blank"
                              >
                                {item.content}
                              </Typography.Link>
                            </Col>
                            <Col span={6}>
                              <div style={{ textAlign: "right" }}>
                                <div>
                                  <Typography.Text style={{ color: "#6F6F6F" }}>
                                    {item.code}
                                  </Typography.Text>
                                </div>
                                <div>
                                  <Typography.Text style={{ color: "#6F6F6F" }}>
                                    {item.time}
                                  </Typography.Text>
                                </div>
                              </div>
                            </Col>
                          </Row>
                          {/* <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <div>
                              <Typography.Text style={{ color: "#6F6F6F" }}>
                                {item.content}
                              </Typography.Text>
                            </div>
                            <div
                              style={{
                                width: 100,
                                textAlign: "right",
                                marginLeft: 20,
                              }}
                            >
                              <div>
                                <Typography.Text style={{ color: "#6F6F6F" }}>
                                  {item.code}
                                </Typography.Text>
                              </div>
                              <div>
                                <Typography.Text style={{ color: "#6F6F6F" }}>
                                  {item.time}
                                </Typography.Text>
                              </div>
                            </div>
                          </div> */}
                        </div>
                      </Col>
                    );
                  })}
              </Row>
            </div>
          </div>
        </Fade>
      </div>
    </>
  );
};
